<template>
  <transition name="fade">
    <div v-show="isVisible">
      <multi-select
          v-model="selected"
          :options="options"
          :multiple="multiple"
          :searchable="true"
          :close-on-select="!multiple"
          :placeholder="placeholder"
          :track-by="trackKey"
          :label="labelKey"
          :custom-label="o => o[labelKey]"
          :loading="loading"
          :internal-search="false"
          :show-labels="false"
          @select="emitSelection"
          @remove="emitSelection"
          @search-change="onSearch"
      >
        <template slot="singleLabel" slot-scope="{ option }">
          <strong>{{ option[labelKey] }}</strong>
        </template>
        <span slot="noOptions"><strong>Liste vide</strong></span>
        <span slot="noResult"><strong>Aucun résultat</strong></span>
      </multi-select>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'GenericSelect',
    props: {
      value: [String, Number, Array, Object, null],
      options: {
        type: Array,
        required: true
      },
      labelKey: {
        type: String,
        default: 'label'
      },
      trackKey: {
        type: String,
        default: 'id'
      },
      placeholder: {
        type: String,
        default: 'Sélectionnez une option'
      },
      multiple: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        selected: this.multiple ? [] : null,
        isVisible: true
      };
    },
    watch: {
      value: {
        immediate: true,
        handler(newVal) {
          this.syncSelectedFromValue(newVal);
        }
      },
      options(newOptions) {
        this.syncSelectedFromValue(this.value);
      }
    },
    methods: {
      syncSelectedFromValue(val) {
        if (this.multiple) {
          const items = this.options.filter(o =>
              Array.isArray(val) && val.includes(o[this.trackKey])
          );
          this.selected = items;
        } else {
          const match = this.options.find(o => o[this.trackKey] === val) || null;
          this.selected = match;
        }
      },
      emitSelection() {
        if (this.multiple) {
          const ids = this.selected.map(o => o[this.trackKey]);
          this.$emit('input', ids);
          this.$emit('change-object', this.selected);
        } else {
          this.$emit('input', this.selected ? this.selected[this.trackKey] : null);
          this.$emit('change-object', this.selected);
        }
      },
      onSearch(query) {
        this.$emit('search-change', query);
      }
    }
  };
</script>

<style scoped>
/* Animation simple fade-in */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
